/** VERSION: custom **/

// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
    }, label: {
      search: {
        searchTotalResult: "Shop at All4cycling",
        searchTotalResults: "Shop at All4cycling",
        enableFixHeadTitle: true
      }
    }
};

(function() {
	BoostPFS.inject(this);

    Labels.search.seoTitleOne = boostPFSConfig.shop.name + ' | Shop at All4cycling';
    Labels.search.seoTitleOther = boostPFSConfig.shop.name + ' | Shop at All4cycling'; 

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	InstantSearchResultItemProduct.prototype.getTemplate = function (tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`;
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`;
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`;
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`;
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<s>{{compareAtPrice}}</s>&nbsp;
						<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
					</p>
				`;
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">
						<a href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								{{itemProductVendor}}
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`;
		}
	}
    
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      var price = Utils.formatMoney(this.data.price_min);
      var compareAtPrice = '';
      if (this.data && this.data.compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue('search.removePriceDecimal')) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }

      // Build Price
      var result = '';
      if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        } else {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
      }
      return result
      .replace(/{{regularPrice}}/g, '')
      .replace(/{{compareAtPrice}}/g, '');
    }
    /*InstantSearchResultItemProduct.prototype.afterRender = function() {
      if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;
        var currentUrl = Utils.getWindowLocation();
        var quickUrl = '/products/' + data.handle + '?view=boost-pfs-prices';
        if(jQuery.inArray("coming-soon", data.tags) != -1) {
        } else {
          jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();
          jQ.ajax({
            url: quickUrl, 
            success: function(result) {
              jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').html(result)
            }
          }); 
        } 
      }
    } */

    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
        Globals.instantSearchQueryParams.h_options = [Shopify.locale];
    }

})();